import { render, staticRenderFns } from "./GreenCard.vue?vue&type=template&id=6812af0d&scoped=true&"
import script from "./GreenCard.vue?vue&type=script&lang=ts&"
export * from "./GreenCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812af0d",
  null
  
)

export default component.exports